import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  CheckIbanResponseIbanValidationEnum,
  NegotiationIbanRequest,
  QineticNegotiationApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export interface SubmitIbanPayload extends NegotiationIbanRequest {
  isIbanValid: boolean;
}
export const submitIban = createAsyncThunk<
  SubmitIbanPayload,
  NegotiationIbanRequest,
  ThunkApi
>("submitIban", async (ibanData, { rejectWithValue, getState }) => {
  const MAX_IBAN_ATTEMPTS = 1;

  try {
    const {
      loan: {
        iban: { ibanAttempts },
      },
    } = getState();

    const response = await new QineticNegotiationApi().saveIban(
      ibanData,
      ibanAttempts === MAX_IBAN_ATTEMPTS,
    );
    const { data } = response;

    return {
      ...ibanData,
      isIbanValid:
        data.ibanValidation === CheckIbanResponseIbanValidationEnum.Success,
    };
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio IBAN",
      description:
        "Non siamo riusciti a salvare il tuo IBAN.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
